// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"744c0b8e","127":"0e8cb975","213":"626f4c5b","397":"773aa84b","453":"4b2bfc18","505":"3edd9638","513":"97578f35","588":"05e22a0e","627":"f7f5e214","653":"35439369","837":"dc403025","966":"e28e9a0f"}[chunkId] + ".chunk.js";
};